import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITag } from '../../models/tags.models';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { AddTag, AddTagSuccess, UpdateTag, UpdateTagSuccess } from '../../store/tags.actions';
import { Observable, Subject, of, take, takeUntil } from 'rxjs';
import { selectCanDo } from 'src/app/core/store/permissions/permissions.selectors';

@Component({
  selector: 'app-add-tags',
  templateUrl: './add-tags.component.html',
  styleUrls: ['./add-tags.component.scss']
})
export class AddTagsComponent implements OnInit, OnDestroy {

  form!: FormGroup;
  isUpdate = false;
  canSubmit = false;
  canSubmit$: Observable<boolean> = of(false);

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<AddTagsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITag,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private actions$: Actions
  ) { }

  ngOnInit(): void {
    this.isUpdate = !!this.data;
    this.form = this.fb.group({
      name: new FormControl(this.data?.name ?? '', Validators.required),
      description: new FormControl(this.data?.description ?? ''),
      color: new FormControl(this.data?.color ?? ''),
    })

    this.canSubmit$ = this.store.select(selectCanDo('product', this.isUpdate ? 'edit' : 'create'));
    this.canSubmit$.pipe(takeUntil(this.destroy$)).subscribe(canSubmit => {
      this.canSubmit = canSubmit;
      canSubmit ? this.form.enable({ emitEvent: false }) : this.form.disable({ emitEvent: false });
    });

    this.actions$.pipe(ofType(AddTagSuccess, UpdateTagSuccess), take(1)).subscribe(() => this.closed());
  }


  toHex(value: string | null | undefined): string {
    if (!value) return '#000000';
    const v = value.trim();
    return /^#[0-9a-fA-F]{6}$/.test(v) ? v : '#000000';
  }

  onColorPicked(hex: string): void {
    if (!this.canSubmit) return;
    this.form.get('color')?.setValue((hex || '').toLowerCase());
  }

  save(): boolean | void {
    if (!this.canSubmit) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false;
    }
    if (this.data) {
      this.store.dispatch(UpdateTag({ id: this.data.id, tag: this.form.value }));
    } else {
      this.store.dispatch(AddTag({ tag: this.form.value }));
    }
  }

  submitPermission() {
    return { module: 'product', action: this.isUpdate ? 'edit' : 'create' };
  }

  closed() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
